import React from 'react';
import { LeaderboardHeader } from './components/LeaderboardHeader/LeaderboardHeader';
import { LeaderboardContent } from './components/LeaderboardContent/LeaderboardContent';
import { LeaderboardSidebar } from './components/LeaderboardSidebar/LeaderboardSidebar';
import { useLeaderboardSummary } from '../../hooks/useLeaderboardSummary';
import { useActiveLeaderboardEvent } from '../../hooks/useActiveLeaderboardEvent';
import './Leaderboard.scss';

export const Leaderboard: React.FC = () => {
  const { activeEvent } = useActiveLeaderboardEvent();
  const { summary } = useLeaderboardSummary(activeEvent?.id);

  return (
    <div className="leaderboard-page">
      <h1>Leaderboard</h1>
      <LeaderboardHeader
        startDate={summary?.eventStartDate}
        endDate={summary?.eventEndDate}
        selectedEventId={activeEvent?.id}
      />
      <div className="leaderboard-main">
        <LeaderboardContent />
        <LeaderboardSidebar summary={summary} />
      </div>
    </div>
  );
};
